module.exports = __webpack_public_path__ + "img/pålestikk_double2.b21d95ca.jpg";